import useIsMobile from 'Hooks/useIsMobile';

// Shown on the create-case page while the saved draft loads, in the same
// layout as the form (step sidebar + form panel) so the page keeps its shape
// and then fills in. Only grey placeholder bars - no real text.
const Bar = ({ className = '' }) => <div className={`rounded bg-navy/[.08] ${className}`} />;

function FieldRows({ count, mobile }) {
  return (
    <div className={`flex flex-col ${mobile ? 'gap-5 mt-6' : 'gap-6 mt-8'}`}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className='flex flex-col gap-2.5'>
          <Bar className={`h-3 ${i % 2 ? 'w-[38%]' : 'w-[26%]'}`} />
          <div className={`${mobile ? 'h-11' : 'h-12'} rounded-md bg-white border border-navy/[.1]`} />
        </div>
      ))}
    </div>
  );
}

function ButtonsRow({ mobile }) {
  return (
    <div className={`flex ${mobile ? 'flex-col-reverse gap-2.5 mt-8' : 'justify-between items-center mt-10'}`}>
      <div className={`h-11 rounded-md bg-navy/[.06] ${mobile ? 'w-full' : 'w-[110px]'}`} />
      <div className={`h-11 rounded-md bg-brass/[.25] ${mobile ? 'w-full' : 'w-[150px]'}`} />
    </div>
  );
}

export default function CreateCaseSkeleton() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div aria-busy='true' aria-label='Loading your case form' className='w-full bg-cream min-h-full font-plexsans animate-pulse'>
        <div className='bg-navy px-[18px] pt-4 pb-3.5'>
          <div className='h-2.5 w-[70px] rounded bg-ivory/[.18] mb-2.5' />
          <div className='h-[5px] rounded-full bg-ivory/[.12]' />
        </div>
        <div className='bg-ivory px-[18px] pt-[22px] pb-6'>
          <Bar className='h-6 w-[65%] mb-2.5' />
          <Bar className='h-3.5 w-[90%]' />
          <FieldRows count={4} mobile />
          <ButtonsRow mobile />
        </div>
      </div>
    );
  }

  return (
    <div aria-busy='true' aria-label='Loading your case form' className='w-full bg-cream min-h-full font-plexsans animate-pulse'>
      <div className='w-full flex items-stretch'>
        <div className='w-[240px] flex-none bg-navy py-7 hidden lg:block'>
          <div className='px-7 pb-5'><div className='h-3 w-[110px] rounded bg-ivory/[.2]' /></div>
          {[120, 96, 132, 104, 84].map((w, i) => (
            <div key={i} className='flex items-center gap-3 px-7 py-3 border-l-[3px] border-transparent'>
              <div className='w-[22px] h-[22px] rounded-full flex-none bg-ivory/[.12]' />
              <div className='h-3 rounded bg-ivory/[.12]' style={{ width: w }} />
            </div>
          ))}
        </div>
        <div className='flex-1 bg-ivory px-12 py-10 min-w-0'>
          <div className='flex justify-between items-center mb-3'>
            <Bar className='h-3 w-[90px]' />
            <Bar className='h-3 w-[80px]' />
          </div>
          <Bar className='h-8 w-[45%] mb-3' />
          <Bar className='h-4 w-[70%]' />
          <FieldRows count={5} />
          <ButtonsRow />
        </div>
      </div>
    </div>
  );
}
